import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const ThumbnailWrapper = styled.div`
  height: 145px;
  position: relative;
  flex-basis: 145px;
  flex-grow: 0;
  flex-shrink: 0;
`

const ThumbnailImg = styled.img`
  bottom: 0;
  border-radius: 0.5rem;
  box-shadow: 0 4px 10px 0 rgba(0,0,0,0.50);
  left: 0;
  object-fit: cover;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
`

const Thumbnail = ({ src }) => {
  let transformedSrc = src

  if (src) {
    const transformString = "ar_1:1,c_fill/c_scale,w_500,dpr_auto,fl_lossy,f_auto"
    transformedSrc = src.replace(
      /https:\/\/res.cloudinary.com\/spokenlayer\/image\/upload\/d_SpokenLayer_Logo_Verticle_fb9a1b.png/g,
      `https://res.cloudinary.com/spokenlayer/image/upload/${transformString}/d_SpokenLayer_Logo_Verticle_fb9a1b.png/v1`
    )
  }

  return (
    <ThumbnailWrapper>
      <ThumbnailImg src={transformedSrc} alt='Logo' />
    </ThumbnailWrapper>
  )
}

Thumbnail.propTypes = {
  src: PropTypes.string.isRequired,
}

export default Thumbnail



// WEBPACK FOOTER //
// ./src/components/atoms/Thumbnail/index.js